/**
 * @type {string}
 */
export const INVALID_INVOICE_NUMBER_ERROR = 'Unable to find a matching invoice number. Please try again later or contact customer support.';

/**
 * @type {string}
 */
export const SEND_RETURN_RESPONSE_ERROR = 'Unable to confirm return. Please try again later or contact customer support.';

/* eslint-disable sort-keys */
export const Steps = {
	SelectProducts: 1,
	ShippingPayment: 2,
	Review: 3
};
/* eslint-enable sort-keys */

/**
 * Used as the default value for state if no url parameter is found.
 *
 * @type {import('../types').RMAState}
 */
export const DEFAULT_RMA_STATE = {
	mivaOrderId: 0,
	packageHeight: '',
	packageLength: '',
	packageWidth: '',
	pickupDate: '',
	pickupLocation: '',
	productStates: [],
	specialInstructions: '',
	step: Steps.SelectProducts,
	total: 0,
	valid: false
};

/**
 * The query parameter key used to retreive a state by it's id.
 *
 * @type {string}
 */
export const STATE_ID_QUERY_PARAM = 'state_id';

/**
 * @type {import('../types').RMAReturnData}
 */
export const DEFAULT_RETURN_DATA = {
	itemCondition: '',
	reason: '',
	serialNumber: '',
	uploadData: [],
	valid: false
};

/**
 * @type {import('../types').ItemCondition[]}
 */
export const ITEM_CONDITIONS = [
	{
		code: 'NEW',
		description: 'New, never opened'
	},
	{
		code: 'OPEN',
		description: 'Open box'
	},
	{
		code: 'INSTALLED',
		description: 'Installed'
	}
];
